import { Children, useState } from "react";
import { AddIcon, FormFieldOptionIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function FormFieldOptions() {
  const [formOption, setFormOption] = useState([
    "[Form Field Option Title]",
    "[Form Field Option Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Form Fields</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            formOption.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  secondaryData="[Field Type]"
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/form-field-options/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setFormOption(() => [...formOption, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setFormOption(() =>
                      formOption.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <FormFieldOptionIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
